// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pop-up-loading[data-v-4b3e4018]{flex:1;display:flex;align-items:center;justify-content:center;width:100%;height:100%}.pop-up-loading img[data-v-4b3e4018]{width:120px;filter:invert(37%) sepia(98%) saturate(644%) hue-rotate(341deg) brightness(103%) contrast(100%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
